import { defineComponent, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import Brands from '@/components/Brands.vue';
import FAQ from '@/components/FAQ.vue';
import Hero from '@/components/Hero.vue';
import Portfolio from '@/components/Portfolio.vue';
import Realizations from '@/components/Realizations.vue';
import Services from '@/components/Services.vue';
import { setHead } from '@/composables/useHead';
export default defineComponent({
    name: 'Home',
    components: {
        Hero, Portfolio, Brands, Services, Realizations, FAQ,
    },
    setup() {
        const { t } = useI18n();
        onMounted(() => {
            setHead({
                title: t('seo.home.title'),
                description: t('seo.home.description'),
                basePath: '/',
                ogImage: 'https://www.travellingdominika.com/og-image.jpg',
            });
        });
    },
});
